import React, { useState } from "react";
import { useAppContext } from "../utils/context/app-context";
import { SelectInput } from "../components/FormComponents";
import {
	AlertMessage,
	Button,
	ContentContainer,
	TitleHeader,
} from "../components/UiComponents";
import { buildDateOutline } from "../components/CourseComponents";
import parse from "date-fns/parse";
import format from "date-fns/format";
import useDocumentTitle from "../components/useDocumentTitle";

function PreviousTeachingLogsPage() {
	const { state, api } = useAppContext();
	useDocumentTitle("Previous Teaching Logs");
	const [selectedCourseId, setSelectedCourseId] = useState("");
	const [fetchingLogs, setFetchingLogs] = useState(false);
	const [fetchingLogsError, setFetchingLogsError] = useState(null);
	const [submitted, setSubmitted] = useState(false);
	const [logs, setLogs] = useState([]);

	function handleCourseChanged(e) {
		if (e?.value) {
			setSelectedCourseId(e.value);
		} else {
			setSelectedCourseId("");
		}
	}

	async function handleSubmit(e) {
		e.preventDefault();
		setLogs([]);
		setFetchingLogs(true);
		setFetchingLogsError(null);
		setSubmitted(false);

		const { data, error } = await api.fetchData(
			`/course-teaching-logs-for-tutor`,
			"POST",
			{ course_id: selectedCourseId }
		);

		if (data?.data) {
			setLogs(data.data);
			setFetchingLogs(false);
			setSubmitted(true);
		} else {
			setFetchingLogs(false);
			setFetchingLogsError(error);
			setSubmitted(true);
		}
	}

	function buildCourseName(course) {
		return `${course.title} | ${course.venue_name} | ${buildDateOutline(
			course
		)}`;
	}

	const courseOptions = state.past_courses.map((course) => {
		return {
			value: course.id,
			label: buildCourseName(course),
		};
	});

	return (
		<div className="dashboard">
			<ContentContainer classes="mb-4">
				<TitleHeader title="Previous Teaching Logs" />
				{state.past_courses.length > 0 ? (
					<div className="previous-teaching-logs">
						<form action="" onSubmit={handleSubmit} className="mb-4">
							<SelectInput
								label="Course"
								name="course"
								options={courseOptions}
								onChange={handleCourseChanged}
								value={courseOptions.find(
									(option) => option.value === selectedCourseId
								)}
								placeholder="Select a course"
							/>

							<Button
								text={fetchingLogs ? "Fetching Logs..." : "View Logs"}
								type="tertiary"
								buttonType="submit"
								size="sm"
								disabled={!selectedCourseId || fetchingLogs}
							/>
						</form>
						{submitted && fetchingLogsError && (
							<AlertMessage
								type="error"
								message="An error occurred fetching the logs"
							/>
						)}
						{submitted && logs.length > 0 && (
							<div className="teaching-logs-tiles">
								{logs.map((log) => (
									<TeachingLogTile log={log} key={log.id} />
								))}
							</div>
						)}
						{submitted && logs.length === 0 && (
							<p>No logs found for this course</p>
						)}
					</div>
				) : (
					<p>You have no previous courses</p>
				)}
			</ContentContainer>
		</div>
	);
}

const TeachingLogTile = ({ log }) => {
	const {api} = useAppContext();
 	function parsedDate() {
		if (log.date) {
			let date = parse(log.date, "yyyy-MM-dd", new Date());
			return format(date, "EEE, do MMM yyyy");
		}

		return '';
	}

	async function handleViewPdf() {
		// Receive the PDF Blob from the API and render in new tab
		const {data, error} = await api.fetchData(
			`/teaching-logs/${log.id}/pdf`,
			"GET"
		);
		console.log(data)
		if (data) {
			// data is a Blob, open in new tab
			const file = new Blob([data], { type: "application/pdf" });
			const fileURL = URL.createObjectURL(file);
			console.log(fileURL)
			window.open(fileURL);
		}

		if (error) {
			console.log(error);
		}
	}

	return (
		<div className="teaching-log-tile">
			<div className="teaching-log-tile__header">
				<p className="teaching-log-tile__date">
					{parsedDate()}
				</p>
			</div>
			<Button icon="download" onClick={handleViewPdf} text="View PDF" size="sm" type="primary" />
		</div>
	);
};

export default PreviousTeachingLogsPage;
